import { render, staticRenderFns } from "./TemplateGalleryPlaceholderCard.vue?vue&type=template&id=26c66172&scoped=true"
var script = {}
import style0 from "./TemplateGalleryPlaceholderCard.vue?vue&type=style&index=0&id=26c66172&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26c66172",
  null
  
)

export default component.exports